import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { InputOtp } from 'primereact/inputotp';
import { Toast } from 'primereact/toast';
import { Dropdown, DropdownChangeEvent, DropdownProps } from 'primereact/dropdown';
import { Slide, Zoom } from "react-awesome-reveal";
import { checkConfirmPassword, checkEmail, checkPassword, checkPhoneNumber, checkText } from "../../Utils/Validator";
import { companyDetailCreate, emailVerifiedOTPSend, loginService, userCreate, fetchCountries, applyPromocode, addBillingAddress, addPayment, otpVerification } from "../../Api/SignupApi";
import { ApiResponse, Country, mapPaymentTypes, PaymentType } from "../../Controllers/Types/ApiResponse";
import { goToTop } from "../../Components/goToTop";
import { Ripple } from "primereact/ripple";
import Payment from 'payment';
import { getAppCurrencyType } from "../../Utils/Common";
//import { useStripe, useElements, PaymentElement, CardElement } from '@stripe/react-stripe-js';
import { loadStripe, PaymentIntent } from "@stripe/stripe-js";
import { baseURL } from "../../Api/ApiConstant";
import { Skeleton } from "primereact/skeleton";
import { Image } from "primereact/image";
import { getPaymentTypes } from "../../Api/CommonApi";
import CheckoutForm from "../PaymentGateWay/CheckoutForm";

interface PlanState {
    userTypeId: number;
    planId: number;
    planName: string;
    numberOfProjects: number;
    monthlyAmount?: number;
    maxLicenseCounts?: number;
}

interface BillingInfo {
    id?: number;
    firstName: string;
    lastName: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    country: string;
    postalCode: string;
}

interface PaymentMethod {
    id?: number;
    type?: string;
    logo?: string;
}

const stripePromise = loadStripe('pk_test_51POtSiIPpmakyoBd7356yA5XQY8ABp8877UI1dpSA0Iku8eMZmtgr9WtOexWpvkulCSl4rCv30SCR0nH0vLvwPtF00HtkjX9d5');


const Signup = () => {
    const location = useLocation();
    const state = location.state as PlanState;
    const currencySymbol = getAppCurrencyType();

    const toast = useRef<Toast>(null);
    const navigate = useNavigate();
    const [page, setPage] = useState<number>(1);
    const [step, setStep] = useState<'Plan' | 'Sign up' | 'Billing info' | 'Payment' | 'Welcome'>('Sign up');
    const [loading, setLoading] = useState<boolean>(false);
    const [reSendLoading, setReSendLoading] = useState<boolean>(false);
    const [seconds, setSeconds] = useState<number>(0);
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
    const [showWelcome, setShowWelcome] = useState<boolean>(false);
    const [checked, setChecked] = useState<boolean>(false);
    const [isFree, setIsFree] = useState<boolean>(true);

    const [isSignUpComplete, setIsSignUpComplete] = useState<boolean>(false);
    const [isBillingInfoComplete, setIsBillingInfoComplete] = useState<boolean>(false);
    const [isPaymentComplete, setIsPaymentComplete] = useState<boolean>(false);

    const [email, setEmail] = useState<string>('');
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');

    const [emailError, setEmailErrorMsg] = useState<string>('');
    const [firstNameError, setFirstNameErrorMsg] = useState<string>('');
    const [lastNameError, setLastNameErrorMsg] = useState<string>('');


    const [otp, setOTP] = useState<string | number | undefined>();

    const [otpError, setOtpErrorMsg] = useState<string>('');

    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');

    const [phoneNumberError, setPhoneNumberErrorMsg] = useState<string>('');
    const [passwordError, setPasswordErrorMsg] = useState<string>('');
    const [confirmPasswordError, setConfirmPasswordErrorMsg] = useState<string>('');

    const [companyName, setCompanyName] = useState<string>('');
    const [companyRegNo, setCompanyRegNo] = useState<string>('');
    const [companyEmail, setCompanyEmail] = useState<string>('');
    const [companyPhone, setCompanyPhone] = useState<string>('');
    const [companyAddress, setCompanyAddress] = useState<string>('');
    const [city, setCity] = useState<string>('');
    const [postCode, setPostCode] = useState<string>('');

    const [companyNameError, setCompanyNameErrorMsg] = useState<string>('');
    const [companyRegNoError, setCompanyRegNoErrorMsg] = useState<string>('');
    const [companyEmailError, setCompanyEmailErrorMsg] = useState<string>('');
    const [companyPhoneError, setCompanyPhoneErrorMsg] = useState<string>('');
    const [companyAddressError, setCompanyAddressErrorMsg] = useState<string>('');
    const [cityError, setCityErrorMsg] = useState<string>('');
    const [postCodeError, setPostCodeErrorMsg] = useState<string>('');

    const [userId, setUserId] = useState<number>();


    /*  For billing info */
    const samplePromoCode = 'NUVAY2025';
    const sampleBillingInfoData: BillingInfo = {
        id: 1,
        firstName: 'John',
        lastName: 'Doe',
        addressLine1: '1234 Main St',
        addressLine2: 'Apt 123',
        city: 'Los Angeles',
        country: 'United States',
        postalCode: '90001',
    }

    const [isAutofilled, setIsAutofilled] = useState<boolean>(false);
    const [isSaveAddress, setIsSaveAddress] = useState<boolean>(false);
    const [promoCode, setPromoCode] = useState<string>('');
    const [promoCodeApplied, setPromoCodeApplied] = useState<boolean>(false);
    const [promoCodeError, setPromoCodeError] = useState<string>('');
    const [promoCodeFocused, setPromoCodeFocused] = useState<boolean>(false);
    const [promoCodeLoading, setPromoCodeLoading] = useState<boolean>(false);

    const [offer, setOffer] = useState<number>(0);
    const [couponDiscount, setCouponDiscount] = useState<number>(0);
    const [subTotal, setSubTotal] = useState<number>(0);
    const [tax, setTax] = useState<number>(0);
    const [taxAmount, setTaxAmount] = useState<number>(0);
    const [total, setTotal] = useState<number>(0);

    const [billingFirstName, setBillingFirstName] = useState<string>('');
    const [billingLastName, setBillingLastName] = useState<string>('');
    const [billingAddressLine1, setBillingAddressLine1] = useState<string>('');
    const [billingAddressLine2, setBillingAddressLine2] = useState<string>('');
    const [billingCity, setBillingCity] = useState<string>('');
    const [billingCountry, setBillingCountry] = useState<string>('');
    const [billingPostalCode, setBillingPostalCode] = useState<string>('');

    const [billingFirstNameError, setBillingFirstNameError] = useState<string>('');
    const [billingLastNameError, setBillingLastNameError] = useState<string>('');
    const [billingAddressLine1Error, setBillingAddressLine1Error] = useState<string>('');
    const [billingAddressLine2Error, setBillingAddressLine2Error] = useState<string>('');
    const [billingCityError, setBillingCityError] = useState<string>('');
    const [billingCountryError, setBillingCountryError] = useState<string>('');
    const [billingPostalCodeError, setBillingPostalCodeError] = useState<string>('');

    const [loadingPaymentMethods, setLoadingPaymentMethods] = useState<boolean>(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<PaymentType | null>(null);
    const [purchasePaidTotal, setPurchasePaidTotal] = useState<number>(0);
    const [showPurchaseCheckoutForm, setShowPurchaseCheckoutForm] = useState<boolean>(false);

    /*  */

    /* For payment */
    const [paymentpage, setPaymentPage] = useState<number>(1);
    const [paymentStatus, setPaymentStatus] = useState<'Success' | 'Failed' | ''>('');
    const [paymentMethodsData, setPaymentMethodsData] = useState<PaymentType[]>([]);

    // const samplePaymentMethods: PaymentMethod[] = [
    //     {
    //         "id": 1,
    //         "type": "Stripe",
    //         "logo": "https://www.admin.traqdo.com/storage/paymentType/ag26awcqAnfiMk29Xpj3lqrpHDxuPR24QI1pe37b.png"
    //     },
    //     {
    //         "id": 2,
    //         "type": "PayPal",
    //         "logo": "https://www.paypalobjects.com/digitalassets/c/website/logo/full-text/pp_fc_hl.svg"
    //     },
    //     {
    //         "id": 3,
    //         "type": "Payoneer",
    //         "logo": "https://www.payoneer.com/wp-content/themes/payo/assets/img/payoneer-dark-logo.svg"
    //     }
    // ]
    const [cardNumber, setCardNumber] = useState<string>("");
    const [expiryDate, setExpiryDate] = useState<string>("");
    const [cvv, setCvv] = useState<string>("");

    const [cardNumberError, setCardNumberError] = useState<string | null>(null);
    const [expiryDateError, setExpiryDateError] = useState<string | null>(null);
    const [cvvError, setCvvError] = useState<string | null>(null);

    const [isSaveCardDetail, setIsSaveCardDetail] = useState<boolean>(false);
    /*  */

    useEffect(() => {
        const monthlyAmount = state?.monthlyAmount as number;
        if (monthlyAmount > 0) {
            setIsFree(false);
        } else if (monthlyAmount === 0) {
            setIsFree(true);
        }

        setTax(0);


    }, [state]);

    useEffect(() => {
        if (state.monthlyAmount && state.numberOfProjects) {
            calculateSummary(0);
        }
    }, [tax]);

    const [countries, setCountries] = useState<Country[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<Country | null>(null);

    useEffect(() => {
        const getCountries = async () => {
            try {
                const data = await fetchCountries();
                const activeCountries = data.filter((country) => country.status === 1);
                setCountries(activeCountries);
                setSelectedCountry(activeCountries[0]);
            } catch (error) {
                console.error(error)
            }
        };

        getCountries();
    }, []);

    useEffect(() => {
        const handleGetPaymentTypes = async () => {
            setLoadingPaymentMethods(true)
            const res = await getPaymentTypes();
            setLoadingPaymentMethods(false)

            if (res.status) {
                setPaymentMethodsData(mapPaymentTypes(res.body.data));
            }
        }
        handleGetPaymentTypes();
    }, []);

    const handlePurchasePaymentSuccess = async (paymentIntent: PaymentIntent | undefined) => {
        if (paymentIntent?.status === "succeeded") {
            setShowPurchaseCheckoutForm(false);

            const user_id = localStorage.getItem('user_id');

            const buyLicenseResult = await addPayment(
                Number(user_id),
                selectedPaymentMethod?.id!,
                state.planId,
                subTotal,
                couponDiscount,
                taxAmount,
                total,
                state.numberOfProjects,
                paymentIntent.id,
            );

            if (buyLicenseResult.status) {
                setShowWelcome(true);
                setStep('Welcome');

                setTimeout(() => {
                    setShowWelcome(false);
                    /* user login */
                    userLogin();
                    navigate('/auth/login');
                    //navigate('/dash-board');
                }, 3000);
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "An error occurred in the payment.",
                        life: 3000,
                    });
                }
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: "error",
                    summary: "Failed",
                    detail: "An error occurred in the payment.",
                    life: 3000,
                });
            }
        }
    };

    const selectedCountryTemplate = (option: Country, props: DropdownProps) => {
        if (option) {
            return (
                <div className="d-flex gap-3 align-items-center">
                    <img
                        src={baseURL + '/' + option?.country_logo}
                        alt={option?.country_name}
                        className={`mr-2`}
                        style={{ width: '22px', height: '22px' }}
                    />
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const countryOptionTemplate = (option: Country) => {
        return (
            <div className="d-flex gap-3 align-items-center">
                <img
                    src={baseURL + '/' + option?.country_logo}
                    alt={option?.country_name}
                    className={`mr-2`}
                    style={{ width: '22px', height: '22px' }}
                />
                <div>{option?.country_name}</div>
            </div>
        );
    };

    // For showing password strength
    const header = <div className="font-bold mb-3">Password Strength</div>;
    const footer = (
        <React.Fragment>
            <Divider />
            <p className="mt-2">Suggestions</p>
            <ul className="pl-2 ml-2 mt-0 line-height-3">
                <li>At least one lowercase</li>
                <li>At least one uppercase</li>
                <li>At least one numeric</li>
                <li className="mb-0">Minimum 8 characters</li>
            </ul>
        </React.Fragment>
    );
    ////

    const goBack = () => {
        if (page === 2) {
            setPage(1);
        } else if (page === 3) {
            setPage(2);
        } else if (page === 4) {
            setPage(3);
        }
        goToTop();
    }

    /* ************************************* OTP send part - start ************************************ */
    const handleVerifyEmail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentials()) {
            setLoading(true);
            const data = await emailVerifiedOTPSend(email);
            setLoading(false);

            /* hide error massage */
            hideAPIError();

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIError(key, value[0])
                    ))
                }
            } else {

                /* *******timer start OTP send ****** */
                setSeconds(60);
                setIsButtonDisabled(true);
                /* *******timer start OTP send ****** */

                setLoading(false);
                setPage(2);

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'OTP has been sent successfully, check your email inbox.',
                        life: 3000
                    });
                }
                goToTop();
            }

        } else {
        }


    }

    function checkCredentials(): boolean {
        const isEmailValid = checkEmail(email, true, setEmailErrorMsg);
        const isFirstNameValid = checkText(firstName, true, setFirstNameErrorMsg);
        const isLastNameValid = checkText(lastName, true, setLastNameErrorMsg);

        return isEmailValid && isFirstNameValid && isLastNameValid;
    }

    /* ************************************* OTP send part - end ************************************ */


    /* ************************************* OTP check part - start ************************************ */
    const handleVerifyOTP = async (e: React.FormEvent) => {
        e.preventDefault();


        if (checkOTPInput(Number(otp))) {
            setLoading(true);
            const response = await otpVerification(email, Number(otp));
            setLoading(false);

            if (response.status) {
                setPage(3);
                goToTop();
            } else {

                setOtpErrorMsg(response.error!)

                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'OTP verification failed',
                        life: 3000
                    });
                }
            }
        }
    };

    const checkOTPInput = (OTP: Number): boolean => {
        if (!OTP) {
            setOtpErrorMsg('OTP field is required.');
            return false;
        } else {
            setOtpErrorMsg('');
            return true;
        }
    };
    /* ************************************* OTP check part - end ************************************ */


    /* ************************************* OTP resend part - start ************************************ */
    useEffect(() => {
        if (seconds > 0) {
            const timerId = setTimeout(() => {
                setSeconds(seconds - 1);
            }, 1000);
            return () => clearTimeout(timerId);
        } else {
            setIsButtonDisabled(false);
        }
    }, [seconds]);

    const handleResendCode = async (e: React.FormEvent) => {
        e.preventDefault();

        /* ******** Resend OTP ***** */
        setOtpErrorMsg('')
        setLoading(true);
        const data = await emailVerifiedOTPSend(email);
        setLoading(false);

        /* ******** Resend OTP ***** */


        setSeconds(60);
        setIsButtonDisabled(true);
        if (toast.current) {
            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: 'OTP has been sent successfully, check your email inbox.',
                life: 3000
            });
        }
    };
    /* ************************************* OTP resend part - end ************************************ */




    /* ************************************* User create part - start ************************************ */
    const handleSaveAccountDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        if (UserCreateCheckCredentials()) {
            const countryId = selectedCountry?.id!;
            const phoneNo = selectedCountry?.country_code + ' ' + phoneNumber;

            setLoading(true);
            const data = await userCreate(state?.userTypeId, countryId, firstName, lastName, email, phoneNo, password, confirmPassword);
            setLoading(false);



            /* hide error massage */
            hideAPIError();

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIError(key, value[0])
                    ))
                }
            } else {

                setUserId(Number(data.user_id) || 0)
                localStorage.setItem('user_id', String(data.user_id) || '');
                localStorage.setItem("token", String(data.token) || '');


                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'User created successfully.',
                        life: 3000
                    });
                }

                setLoading(false);
                setPage(4);

                goToTop();
            }

        } else {
        }

    };

    function UserCreateCheckCredentials(): boolean {
        const isValidPhoneNumber = checkPhoneNumber(phoneNumber, true, setPhoneNumberErrorMsg);
        const isValidPassword = checkPassword(password, true, setPasswordErrorMsg);
        const isValidConfirmPassword = checkConfirmPassword(confirmPassword, password, true, setConfirmPasswordErrorMsg);

        return isValidPhoneNumber && isValidPassword && isValidConfirmPassword;
    }

    /* ************************************* User create part - end ************************************ */


    /* ************************************* Company details create part  - start ************************************ */
    const handleSaveCompanyDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        /* hide massage */
        hideAPIErrorCompany();
        if (CompanyDetailsCheckCredentials()) {
            setLoading(true);
            const data = await companyDetailCreate(Number(userId), companyName, companyRegNo, companyEmail, companyPhone, companyAddress, postCode, city);
            setLoading(false);

            goToTop();

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorCompany(key, value[0])
                    ))
                }
            } else {

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Company details created successfully.',
                        life: 3000
                    });
                }

                setIsSignUpComplete(true);

                if (isFree === true) {
                    setShowWelcome(true);
                    setStep('Welcome');

                    setTimeout(() => {
                        setShowWelcome(false);
                        /* user login */
                        userLogin();
                        navigate('/auth/login');
                        //navigate('/dash-board');
                    }, 3000);

                } else {
                    setStep('Billing info');
                }
            }
        }

    };

    const handleSkipCompanyDetails = async (e: React.FormEvent) => {
        setIsSignUpComplete(true);

        if (isFree === true) {
            setShowWelcome(true);
            setStep('Welcome');

            setTimeout(() => {
                setShowWelcome(false);
                /* user login */
                userLogin();
                navigate('/auth/login');
                //navigate('/dash-board');
            }, 3000);

        } else {
            setStep('Billing info');
        }
    }

    function CompanyDetailsCheckCredentials(): boolean {
        const isValidCompanyName = checkText(companyName, true, setCompanyNameErrorMsg);


        return isValidCompanyName;
    }

    function hideAPIErrorCompany(): void {
        setCompanyNameErrorMsg('');
        setCompanyRegNoErrorMsg('');
        setCompanyEmailErrorMsg('');
        setCompanyPhoneErrorMsg('');
    }

    function showAPIErrorCompany(keyName: string, error: string): void {
        if (keyName === "company_regno") {
            setCompanyRegNoErrorMsg(error);
        }
        if (keyName === "company_email") {
            setCompanyEmailErrorMsg(error);
        }
        if (keyName === "company_phone") {
            setCompanyPhoneErrorMsg(error);
        }
    }


    /* ************************************* Company details create part  - end ************************************ */


    /* ************************************* User login part - start ************************************ */
    const userLogin = async () => {

        /* ******** User login *********** */
        const data = await loginService(email, password);

        if (data.status) {
            localStorage.setItem('token', data.body?.token || '');
            localStorage.setItem('user_id', String(data.body?.user_id) || '');
            localStorage.setItem('user_type_id', String(data.body?.user_type_id) || '');
            localStorage.setItem('user_type_name', String(data.body?.user_type_name) || '');
            localStorage.setItem('company_name', String(data.body?.company_name) || '');
            localStorage.setItem('currency_symbol', String(data.body?.currency_symbol) || '');
            localStorage.setItem('material_tax_percentage', String(data.body?.material_tax_percentage) || '');
            localStorage.setItem('vat_percentage', String(data.body?.vat_percentage) || '');
        }
        /* ******** User login *********** */

    }
    /* ************************************* User login part - end ************************************ */



    /* ************** API Error massage show ****************** */

    function hideAPIError(): void {
        setEmailErrorMsg('');
        setPhoneNumberErrorMsg('');
    }


    function showAPIError(keyName: string, error: string): void {

        setEmailErrorMsg('');
        setPhoneNumberErrorMsg('');

        if (keyName === "email") {
            setEmailErrorMsg(error);
        }
        if (keyName === "phone") {
            setPhoneNumberErrorMsg(error);
        }
    }
    /* ************** API Error massage show ****************** */


    /* ******************* For Billing info ******************* */
    const handleApplyPromoCode = async (e: React.FormEvent) => {
        e.preventDefault();


        try {

            if (checkPromocodeCredentials()) {
                setPromoCodeLoading(true);


                const response = await applyPromocode(promoCode);

                setPromoCodeLoading(false);


                if (response.status) {

                    const have_offer = response.data['have_offer'];

                    if (have_offer) {
                        const offer = response.data['offer'];

                        calculateSummary(offer);

                    } else {

                        calculateSummary(0);
                    }


                } else {
                    calculateSummary(0);
                }
            }





        } catch (error) {
            console.error('Error applying promo code:', error);
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error applying promo code.',
                    detail: 'There was an error applying the promo code.',
                    life: 3000,
                });
            }
        } finally {
            setPromoCodeLoading(false);
        }
    };

    function checkPromocodeCredentials(): boolean {

        const isPromocodeValid = checkText(promoCode, true, setPromoCodeError);

        return isPromocodeValid;
    }

    const calculateSummary = (offer: number) => {
        if (state.monthlyAmount && state.numberOfProjects) {
            const packageAmount = state.numberOfProjects * state.monthlyAmount!;
            const roundedPackageAmount = Number(packageAmount)
            const couDis = (roundedPackageAmount * offer) / 100;
            const roundedCouDis = Number(couDis.toFixed(2))


            const subTot = roundedPackageAmount - roundedCouDis
            const roundedSubTot = Number(subTot.toFixed(2))

            const taxAmt = (roundedSubTot * tax) / 100;
            const roundedTaxAmt = Number(taxAmt.toFixed(2))

            const tot = roundedSubTot + taxAmt
            const roundedTot = Number(tot.toFixed(2))

            setOffer(offer)
            setCouponDiscount(roundedCouDis)
            setSubTotal(roundedSubTot)
            setTaxAmount(roundedTaxAmt)
            setTotal(roundedTot)
        }

    }

    /* For purchase new subscription */
    const handlePurchasePayWith = (paymentMethod: PaymentType) => {
        setSelectedPaymentMethod(paymentMethod);
        setPurchasePaidTotal(total);
        setShowPurchaseCheckoutForm(true);
    };

    const handleAutofillBillingInfo = () => {
        if (sampleBillingInfoData) {
            setBillingFirstName(sampleBillingInfoData.firstName);
            setBillingLastName(sampleBillingInfoData.lastName);
            setBillingAddressLine1(sampleBillingInfoData.addressLine1);
            setBillingAddressLine2(sampleBillingInfoData.addressLine2);
            setBillingCity(sampleBillingInfoData.city);
            setBillingCountry(sampleBillingInfoData.country);
            setBillingPostalCode(sampleBillingInfoData.postalCode);
        }
    }

    const clearBillingInfo = () => {
        setBillingFirstName('');
        setBillingLastName('');
        setBillingAddressLine1('');
        setBillingAddressLine2('');
        setBillingCity('');
        setBillingCountry('');
        setBillingPostalCode('');
    };

    const handleClearBillingErrors = () => {
        setBillingFirstNameError('');
        setBillingLastNameError('');
        setBillingAddressLine1Error('');
        setBillingAddressLine2Error('');
        setBillingCityError('');
        setBillingCountryError('');
        setBillingPostalCodeError('');
    }

    const handleCheckboxChange = (isChecked: boolean) => {
        setIsAutofilled(isChecked);
        if (isChecked) {
            handleAutofillBillingInfo();
        } else {
            clearBillingInfo();
        }
    };

    const handleSaveBillingInfo = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            if (checkBillingAddressCredentials()) {
                setLoading(true);
                handleClearBillingErrors();

                const user_id = localStorage.getItem('user_id');
                const response: ApiResponse = await addBillingAddress(Number(user_id), billingFirstName, billingLastName, billingAddressLine1, billingAddressLine2, billingCity, billingPostalCode);
                setLoading(false);

                if (response.status) {
                    setIsBillingInfoComplete(true);
                    setStep('Payment');

                    goToTop();

                    if (toast.current) {
                        toast.current.show({
                            severity: 'success',
                            summary: 'Billing info saved.',
                            detail: 'You have successfully saved the billing info.',
                            life: 3000,
                        });
                    }

                } else {
                    if (toast.current) {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Error saving billing info.',
                            detail: 'There was an error saving billing info.',
                            life: 3000,
                        });
                    }
                }
            }
        } catch (error) {
            setLoading(false);
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error saving billing info.',
                    detail: 'There was an error saving billing info.',
                    life: 3000,
                });
            }
        }

    }
    /* ******************************************************** */

    function checkBillingAddressCredentials(): boolean {

        const isFirstNameValid = checkText(billingFirstName, true, setBillingFirstNameError);
        const isLastNameValid = checkText(billingLastName, true, setBillingLastNameError);
        const isAddressLine1Valid = checkText(billingAddressLine1, true, setBillingAddressLine1Error);
        const isCityValid = checkText(billingCity, true, setBillingCityError);
        //const isCountryValid = checkText(billingCountry, true, setBillingCountryError);
        const isPostalCodeValid = checkText(billingPostalCode, true, setBillingPostalCodeError);

        return isFirstNameValid && isLastNameValid && isAddressLine1Valid && isCityValid && isPostalCodeValid;

    }

    const formatCardNumber = (value: string) => {
        const formattedValue = value.replace(/\D/g, '').replace(/(.{4})/g, '$1 ').trim();
        setCardNumber(formattedValue);
    };

    const formatExpiryDate = (value: string) => {
        const formattedValue = value
            .replace(/\D/g, '')
            .replace(/(\d{2})(\d{1,2})/, '$1/$2')
            .slice(0, 5);
        setExpiryDate(formattedValue);
    };

    const validateCardNumber = () => {
        const isValid = Payment.fns.validateCardNumber(cardNumber.replace(/\s+/g, ''));
        setCardNumberError(cardNumber === '' ? 'This field is required.' : isValid ? '' : 'Invalid card number');
        return isValid;
    };

    const validateExpiryDate = () => {
        const [month, year] = expiryDate.split('/');
        const isValid = Payment.fns.validateCardExpiry(month, year);
        setExpiryDateError(expiryDate === '' ? 'This field is required.' : isValid ? '' : 'Invalid expiry date');
        return isValid;
    };

    const validateCvv = () => {
        const cardType = Payment.fns.cardType(cardNumber.replace(/\s+/g, ''));
        const isValid = Payment.fns.validateCardCVC(cvv, cardType);
        setCvvError(cvv === '' ? 'This field is required.' : isValid ? '' : 'Invalid CVV');
        return isValid;
    };



    const handleRetryPayment = () => {
        setPaymentPage(1);
    };

    const handleClearPromoCode = () => {
        setPromoCode('');
        setPromoCodeApplied(false);
        setPromoCodeError('');
        calculateSummary(0)
    }
    /* ******************************************************** */


    return (
        <React.Fragment>
            <Toast ref={toast} />

            <section className="page_initial_section auth_init_section bg-white">
                <img src="/assets/images/page_dec_img.svg" className="page_dec_img" alt="" />
                <img src="/assets/images/page_dec_img.svg" className="page_dec_img image_2" alt="" />
                <div className="container-md">
                    <div className="row">
                        <div className="col-12">
                            <Zoom triggerOnce>
                                <div className="accout_creation_tracking_area">
                                    <div className="acc_track_point plan active"></div>

                                    <div className="acc_track_line active">
                                        <div className="track"></div>
                                    </div>

                                    <div className={`acc_track_point sign_up ${(step === 'Sign up' || isSignUpComplete) ? 'active' : ''}`}></div>

                                    {!isFree && (
                                        <React.Fragment>
                                            <div className={`acc_track_line ${(step === 'Billing info' || isBillingInfoComplete) ? 'active' : ''}`}>
                                                <div className="track"></div>
                                            </div>

                                            <div className={`acc_track_point bill ${(step === 'Billing info' || isBillingInfoComplete) ? 'active' : ''}`}></div>

                                            <div className={`acc_track_line ${(step === 'Payment' || isPaymentComplete) ? 'active' : ''}`}>
                                                <div className="track"></div>
                                            </div>

                                            <div className={`acc_track_point payment ${(step === 'Payment' || isPaymentComplete) ? 'active' : ''}`}></div>
                                        </React.Fragment>
                                    )}

                                    <div className={`acc_track_line ${(step === 'Welcome' || showWelcome) ? 'active' : ''}`}>
                                        <div className="track"></div>
                                    </div>

                                    <div className={`acc_track_point welcome ${(step === 'Welcome' || showWelcome) ? 'active' : ''}`}></div>
                                </div>
                            </Zoom>
                        </div>

                        {step === 'Sign up' ? (
                            <React.Fragment>
                                <div className="col-12 col-xl-7 col-lg-6 mx-auto my-auto sticky_top">
                                    <Zoom triggerOnce>
                                        <div className="page_image_area">
                                            <img src="/assets/images/traqdo_logo.svg" className="page_logo_img" alt="Traqdo" />
                                            <img src="/assets/images/page-image.svg" className="page_image" alt="Traqdo" />
                                        </div>
                                    </Zoom>
                                </div>

                                <div className="col-11 col-xl-5 col-lg-6 col-md-10 col-sm-10 mx-auto">
                                    {page === 1 ? (
                                        <Slide direction="up" triggerOnce>
                                            <article className="page_card h-100">
                                                <h5 className="page_card_sub_head text-center">Create an account</h5>
                                                <p className="page_card_desc text-center">Enter your information below to create an account</p>

                                                <form action="" className="page_form_area">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="firstName" className="custom_form_label is_required">First name</label>
                                                                <InputText
                                                                    id="firstName"
                                                                    value={firstName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Eg: John"
                                                                />

                                                                {firstNameError &&
                                                                    <small className="form_error_msg">{firstNameError}</small>
                                                                }

                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="lastName" className="custom_form_label is_required">Last name</label>
                                                                <InputText
                                                                    id="lastName"
                                                                    value={lastName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Eg: Paterson"
                                                                />

                                                                {lastNameError &&
                                                                    <small className="form_error_msg">{lastNameError}</small>
                                                                }

                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="email" className="custom_form_label is_required">Email</label>
                                                                <InputText
                                                                    id="email"
                                                                    type="email"
                                                                    value={email}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="johndeo@gmail.com"
                                                                />

                                                                {emailError &&
                                                                    <small className="form_error_msg">{emailError}</small>
                                                                }

                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_action_area mt-5">
                                                                <div className="custom_form_check_group">
                                                                    <Checkbox inputId="remeberMe" onChange={e => setChecked(e.checked ?? false)} checked={checked}></Checkbox>
                                                                    <label htmlFor="remeberMe" className="custom_form_check_label2">
                                                                        By checking this, you will agree to our&nbsp;
                                                                        <Link to={'/terms-of-service'} target="_blank">Terms</Link>
                                                                        &nbsp;and&nbsp;
                                                                        <Link to={'/privacy-policy'} target="_blank">privacy policy</Link>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_btn_area mt-0">
                                                                <Button
                                                                    label={`${loading ? 'Processing' : 'VERIFY'}`}
                                                                    className="custom_form_btn letter_spaced w-100"
                                                                    onClick={handleVerifyEmail}
                                                                    loading={loading}
                                                                    disabled={!(email && firstName && lastName && checked)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_bottom_area">
                                                                <p>Already have an account?&nbsp;
                                                                    <Link to={'/auth/login'} onClick={goToTop}>
                                                                        Log In
                                                                    </Link>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </article>
                                        </Slide>
                                    ) : page === 2 ? (
                                        <Slide direction="up" triggerOnce>
                                            <article className="page_card h-100 top_button">
                                                {/* <Button icon="bi bi-arrow-left"
                                                    className="back_button"
                                                    outlined
                                                    aria-label="Back"
                                                    onClick={goBack}
                                                /> */}

                                                <h2 className="page_card_head head_2 text-center">Verification</h2>
                                                <p className="page_card_desc text-center">Please check your email inbox for a 4 digit code</p>

                                                <form action="" className="page_form_area">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="email" className="custom_form_label text-center mb-4">Enter the OTP below</label>

                                                                <InputOtp
                                                                    id="otp"
                                                                    value={otp}
                                                                    onChange={(e) => setOTP(e.value ?? undefined)}
                                                                    integerOnly
                                                                />
                                                                {otpError &&
                                                                    <small className="form_error_msg text-center mt-4">{otpError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_btn_area">
                                                                <Button
                                                                    label={`${reSendLoading ? "Processing" : loading ? "Verifying" : "VERIFY"}`}
                                                                    className="custom_form_btn letter_spaced w-100"
                                                                    onClick={handleVerifyOTP}
                                                                    loading={loading}
                                                                    disabled={!otp}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_bottom_area mb-4">
                                                                <p>Didn’t received the code?&nbsp;
                                                                    <button
                                                                        onClick={handleResendCode}
                                                                        disabled={isButtonDisabled}
                                                                    >
                                                                        <span>Resend Code {isButtonDisabled && `in (${seconds}s)`}</span>
                                                                    </button>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </article>
                                        </Slide>
                                    ) : page === 3 ? (
                                        <Slide direction="up" triggerOnce>
                                            <article className="page_card h-100 top_button">
                                                {/* <Button icon="bi bi-arrow-left"
                                                    className="back_button"
                                                    outlined
                                                    aria-label="Back"
                                                    onClick={goBack}
                                                /> */}
                                                <h5 className="page_card_sub_head text-center">Create an account</h5>
                                                <p className="page_card_desc text-center">Enter your information below to create an account</p>

                                                <form action="" className="page_form_area">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="firstName" className="custom_form_label is_required">First name</label>
                                                                <InputText
                                                                    id="firstName"
                                                                    value={firstName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Eg: John"
                                                                    readOnly
                                                                />

                                                                {firstNameError &&
                                                                    <small className="form_error_msg">{firstNameError}</small>
                                                                }

                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="lastName" className="custom_form_label is_required">Last name</label>
                                                                <InputText
                                                                    id="lastName"
                                                                    value={lastName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Eg: Paterson"
                                                                    readOnly
                                                                />
                                                                {lastNameError &&
                                                                    <small className="form_error_msg">{lastNameError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="email" className="custom_form_label is_required">Email</label>
                                                                <InputText
                                                                    id="email"
                                                                    type="email"
                                                                    value={email}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="johndeo@gmail.com"
                                                                    readOnly
                                                                />
                                                                {emailError &&
                                                                    <small className="form_error_msg">{emailError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="phoneNumber" className="custom_form_label is_required">Phone Number</label>
                                                                <div className="custom_mobile_input_group">
                                                                    <Dropdown
                                                                        value={selectedCountry}
                                                                        onChange={(e: DropdownChangeEvent) => setSelectedCountry(e.value)}
                                                                        options={countries}
                                                                        optionLabel="country_name"
                                                                        valueTemplate={selectedCountryTemplate}
                                                                        itemTemplate={countryOptionTemplate}
                                                                        className="coutry_dropdown"
                                                                    />

                                                                    <InputText
                                                                        className="country_code_input"
                                                                        value={selectedCountry?.country_code}
                                                                        readOnly
                                                                    />

                                                                    <InputText
                                                                        id="phoneNumber"
                                                                        value={phoneNumber}
                                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPhoneNumber(e.target.value)}
                                                                        className="custom_mobile_input"
                                                                        placeholder={`Eg: 123 456 789`}
                                                                        type="number"
                                                                    />
                                                                </div>
                                                                {phoneNumberError &&
                                                                    <small className="form_error_msg">{phoneNumberError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="password" className="custom_form_label is_required">Password</label>
                                                                <Password
                                                                    value={password}
                                                                    inputId="password"
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                                                                    header={header}
                                                                    footer={footer}
                                                                    toggleMask
                                                                    tabIndex={1}
                                                                    className="custom_form_input w-100"
                                                                    placeholder="***********"
                                                                />
                                                                {passwordError &&
                                                                    <small className="form_error_msg">{passwordError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="confirmPasswrord" className="custom_form_label is_required">Confirm password</label>
                                                                <Password
                                                                    value={confirmPassword}
                                                                    inputId="confirmPasswrord"
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmPassword(e.target.value)}
                                                                    feedback={false}
                                                                    toggleMask
                                                                    tabIndex={1}
                                                                    className="custom_form_input w-100"
                                                                    placeholder="***********"
                                                                />
                                                                {confirmPasswordError &&
                                                                    <small className="form_error_msg">{confirmPasswordError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_action_area">
                                                                <div className="custom_form_check_group">
                                                                    <Checkbox inputId="remeberMe" onChange={e => setChecked(e.checked ?? false)} checked={checked}></Checkbox>
                                                                    <label htmlFor="remeberMe" className="custom_form_check_label2">
                                                                        By checking this, you will agree to our&nbsp;
                                                                        <Link to={'/terms-and-conditions'} target="_blank">Terms</Link>
                                                                        &nbsp;and&nbsp;
                                                                        <Link to={'/privacy-policy'} target="_blank">privacy policy</Link>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_btn_area mt-0">
                                                                <Button
                                                                    label={`${loading ? 'Processing' : 'NEXT'}`}
                                                                    className="custom_form_btn letter_spaced w-100"
                                                                    loading={loading}
                                                                    onClick={handleSaveAccountDetails}
                                                                    disabled={!(checked)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_bottom_area">
                                                                <p>Go back to&nbsp;
                                                                    <Link to={'/'}>
                                                                        Log in
                                                                    </Link>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </article>
                                        </Slide>
                                    ) : (
                                        <Slide direction="up" triggerOnce>
                                            <article className="page_card h-100 top_button">
                                                {/* <Button icon="bi bi-arrow-left"
                                                    className="back_button"
                                                    outlined
                                                    aria-label="Back"
                                                    onClick={goBack}
                                                /> */}
                                                <h5 className="page_card_sub_head text-center">Create an account</h5>
                                                <p className="page_card_desc text-center">Enter your company information below to create an account</p>

                                                <form action="" className="page_form_area">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="companyName" className="custom_form_label is_required">Company name</label>
                                                                <InputText
                                                                    id="companyName"
                                                                    value={companyName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Eg: Abc_ consultent"
                                                                />

                                                                {companyNameError &&
                                                                    <small className="form_error_msg">{companyNameError}</small>
                                                                }

                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="companyRegNo" className="custom_form_label">Company registration no.</label>
                                                                <InputText
                                                                    id="companyRegNo"
                                                                    value={companyRegNo}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyRegNo(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Company registration no."
                                                                />

                                                                {companyRegNoError &&
                                                                    <small className="form_error_msg">{companyRegNoError}</small>
                                                                }

                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="companyEmail" className="custom_form_label">Company Email</label>
                                                                <InputText
                                                                    id="companyEmail"
                                                                    type="email"
                                                                    value={companyEmail}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyEmail(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="abc@gmail.com"
                                                                />

                                                                {companyEmailError &&
                                                                    <small className="form_error_msg">{companyEmailError}</small>
                                                                }

                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="companyPhone" className="custom_form_label">Phone Number</label>
                                                                <InputText
                                                                    id="companyPhone"
                                                                    value={companyPhone}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPhone(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Company phone number"
                                                                />

                                                                {companyPhoneError &&
                                                                    <small className="form_error_msg">{companyPhoneError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="companyAddress" className="custom_form_label">Company Address</label>
                                                                <InputText
                                                                    id="companyAddress"
                                                                    value={companyAddress}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyAddress(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Company address"
                                                                />

                                                                {companyAddressError &&
                                                                    <small className="form_error_msg">{companyAddressError}</small>
                                                                }

                                                            </div>
                                                        </div>

                                                        <div className="col-12 col-sm-6">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="city" className="custom_form_label">City</label>
                                                                <InputText
                                                                    id="city"
                                                                    value={city}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCity(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="UK"
                                                                />

                                                                {cityError &&
                                                                    <small className="form_error_msg">{cityError}</small>
                                                                }

                                                            </div>
                                                        </div>

                                                        <div className="col-12 col-sm-6">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="postCode" className="custom_form_label">Post code</label>
                                                                <InputText
                                                                    id="postCode"
                                                                    value={postCode}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPostCode(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="H56GHT"
                                                                />

                                                                {postCodeError &&
                                                                    <small className="form_error_msg">{postCodeError}</small>
                                                                }

                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_btn_area">
                                                                <Button
                                                                    label={`${loading ? 'Processing' : 'SIGN UP'}`}
                                                                    className="custom_form_btn letter_spaced w-100"
                                                                    loading={loading}
                                                                    onClick={handleSaveCompanyDetails}
                                                                />

                                                                <button
                                                                    className={`add_data_btn p-ripple mt-3 mx-auto`}
                                                                    onClick={handleSkipCompanyDetails}
                                                                >
                                                                    Skip
                                                                    <i className="bi bi-skip-end-fill"></i>
                                                                    <Ripple />
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_bottom_area">
                                                                <p>Go back to&nbsp;
                                                                    <Link to={'/'}>
                                                                        Log in
                                                                    </Link>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </article>
                                        </Slide>
                                    )}
                                </div>
                            </React.Fragment>
                        ) : step === 'Billing info' ? (
                            <React.Fragment>
                                <div className="col-12 col-xl-6 col-lg-6 col-md-10 col-sm-10 mx-auto mt-0 mb-auto sticky_top">
                                    <Slide direction="up" triggerOnce>
                                        <article className="page_card h-100">
                                            <h5 className="page_card_sub_head text-start">Summary</h5>

                                            <div className="billing_summary_section mt-4">
                                                <div className="plan_summary_area">
                                                    <h6>{state?.planName} ({state.numberOfProjects} project)</h6>
                                                    <h5>{currencySymbol}&nbsp;{state.numberOfProjects * state.monthlyAmount!}</h5>
                                                </div>
                                            </div>

                                            <div className={`promo_code_area ${promoCodeFocused ? 'focused' : ''}`}>
                                                <input
                                                    type="text"
                                                    className="promo_code_input"
                                                    placeholder="Have a promo code?"
                                                    value={promoCode}
                                                    onFocus={() => setPromoCodeFocused(true)}
                                                    onBlur={() => setPromoCodeFocused(false)}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                        setPromoCode(e.target.value)
                                                    }
                                                    disabled={promoCodeApplied}
                                                />

                                                {promoCode !== '' && (
                                                    <i className="bi bi-x-lg value_clear_icon"
                                                        onClick={handleClearPromoCode}></i>
                                                )}
                                                <button
                                                    className="promo_code_btn p-ripple"
                                                    onClick={handleApplyPromoCode}
                                                    type="button"
                                                    disabled={promoCodeLoading || promoCodeApplied}
                                                >
                                                    {!promoCodeApplied && <Ripple />}
                                                    {promoCodeLoading ? 'Processing' : promoCodeApplied ? 'Applied' : 'Apply'}
                                                </button>
                                            </div>
                                            {promoCodeError &&
                                                <small className="form_error_msg">{promoCodeError}</small>
                                            }

                                            {promoCode !== '' && promoCodeApplied && (
                                                <small className="form_success_msg">
                                                    <i className="bi bi-check-circle-fill me-1"></i> Promo code applied
                                                </small>
                                            )}

                                            <div className="billing_summary_area">
                                                <h5 className="billing_summary_head">Details</h5>

                                                <div className="billing_summary_list">
                                                    <span>Package Rental</span>
                                                    <span>{currencySymbol}&nbsp;{state.numberOfProjects * state.monthlyAmount!}</span>
                                                </div>
                                                <div className="billing_summary_list">
                                                    <span>Coupon discounts ({offer}%)</span>
                                                    <span>{currencySymbol}&nbsp;{couponDiscount}</span>
                                                </div>

                                                <hr className="summary_devide_line" />

                                                <div className="billing_summary_list">
                                                    <span>Sub total</span>
                                                    <span>{currencySymbol}&nbsp;{subTotal}</span>
                                                </div>
                                                <div className="billing_summary_list">
                                                    <span>Tax ({tax}%)</span>
                                                    <span>{currencySymbol}&nbsp;{taxAmount}</span>
                                                </div>

                                                <hr className="summary_devide_line" />

                                                <div className="billing_summary_list">
                                                    <h6>Total</h6>
                                                    <h4>{currencySymbol}&nbsp;{total}</h4>
                                                </div>
                                            </div>
                                        </article>
                                    </Slide>
                                </div>

                                <div className="col-12 col-xl-6 col-lg-6 col-md-10 col-sm-10 mx-auto">
                                    <Slide direction="up" triggerOnce>
                                        <article className="page_card h-100">
                                            <h5 className="page_card_sub_head text-start">Billing address</h5>

                                            <form action="" className="page_form_area mt-4">
                                                {/* <div className="form_autofill_area">
                                                    <label htmlFor="autofil">Auto fill</label>
                                                    <Checkbox
                                                        inputId="autofil"
                                                        onChange={(e) => handleCheckboxChange(e.checked || false)}
                                                        checked={isAutofilled}
                                                    >
                                                    </Checkbox>
                                                </div> */}

                                                {/* Billing info form */}





                                                <div className="row">
                                                    {<div>


                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="name" className="custom_form_label is_required">Name</label>
                                                                <InputText
                                                                    id="billingFirstName"
                                                                    value={billingFirstName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBillingFirstName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="First name"
                                                                />
                                                                {billingFirstNameError &&
                                                                    <small className="form_error_msg">{billingFirstNameError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <InputText
                                                                    id="billingLastName"
                                                                    value={billingLastName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBillingLastName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Last name"
                                                                />

                                                                {billingLastNameError &&
                                                                    <small className="form_error_msg">{billingLastNameError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="address" className="custom_form_label is_required">Address</label>
                                                                <InputText
                                                                    id="billingAddressLine1"
                                                                    value={billingAddressLine1}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBillingAddressLine1(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Address line 1"
                                                                />

                                                                {billingAddressLine1Error &&
                                                                    <small className="form_error_msg">{billingAddressLine1Error}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <InputText
                                                                    id="billingAddressLine2"
                                                                    value={billingAddressLine2}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBillingAddressLine2(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Address line 2"
                                                                />

                                                                {billingAddressLine2Error &&
                                                                    <small className="form_error_msg">{billingAddressLine2Error}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="city" className="custom_form_label is_required">City</label>
                                                                <InputText
                                                                    id="billingCity"
                                                                    value={billingCity}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBillingCity(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="City name"
                                                                />

                                                                {billingCityError &&
                                                                    <small className="form_error_msg">{billingCityError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="country" className="custom_form_label is_required">Country</label>
                                                                <InputText
                                                                    id="billingCountry"
                                                                    value={billingCountry}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBillingCountry(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Country name"
                                                                />

                                                                {billingCountryError &&
                                                                    <small className="form_error_msg">{billingCountryError}</small>
                                                                }
                                                            </div>
                                                        </div> */}

                                                        <div className="col-12">
                                                            <div className="custom_form_group">
                                                                <label htmlFor="postalCode" className="custom_form_label">Postal code</label>
                                                                <InputText
                                                                    id="billingPostalCode"
                                                                    value={billingPostalCode}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBillingPostalCode(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="9876543"
                                                                />

                                                                {billingPostalCodeError &&
                                                                    <small className="form_error_msg">{billingPostalCodeError}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* <div className="col-12">
                                                            <div className="custom_form_action_area">
                                                                <div className="custom_form_check_group">
                                                                    <Checkbox inputId="saveAddress" className="rounded" onChange={e => setIsSaveAddress(e.checked ?? false)} checked={isSaveAddress}></Checkbox>
                                                                    <label htmlFor="saveAddress" className="custom_form_check_label2">
                                                                        Save this address for faster payment.
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                    </div>}

                                                    {/*<div className="col-12">
                                                    
                                                         {<CardElement />}
                                                        
                                                       
                                                    </div>*/}





                                                    <div className="col-12">

                                                        {/* <div className="custom_form_btn_area mt-0">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'Stripe'}`}
                                                                className="custom_form_btn letter_spaced w-100"
                                                                loading={loading}
                                                                onClick={handleCheckout}
                                                            />
                                                        </div> */}

                                                        <div className="custom_form_btn_area mt-0">
                                                            <Button
                                                                label={`${loading ? 'Processing' : 'NEXT'}`}
                                                                className="custom_form_btn letter_spaced w-100"
                                                                loading={loading}
                                                                onClick={handleSaveBillingInfo}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </article>
                                    </Slide>
                                </div>
                            </React.Fragment>
                        ) : step === 'Payment' ? (
                            <React.Fragment>
                                {paymentpage === 1 ? (
                                    <React.Fragment>
                                        <div className="col-12 col-xl-6 col-lg-6 col-md-10 col-sm-10 mx-auto mt-0 mb-auto sticky_top">
                                            <Slide direction="up" triggerOnce>
                                                <article className="page_card h-100">
                                                    <h5 className="page_card_sub_head text-start">Summary</h5>

                                                    <div className="billing_summary_section mt-4">
                                                        <div className="plan_summary_area">
                                                            <h6>{state.planName} ({state.numberOfProjects} project)</h6>
                                                            <h5>{currencySymbol}&nbsp;{state.numberOfProjects * state.monthlyAmount!}</h5>
                                                        </div>
                                                    </div>

                                                    <div className="billing_summary_area">
                                                        <h5 className="billing_summary_head">Details</h5>

                                                        <div className="billing_summary_list">
                                                            <span>Package Rental</span>
                                                            <span>{currencySymbol}&nbsp;{state.numberOfProjects * state.monthlyAmount!}</span>
                                                        </div>
                                                        <div className="billing_summary_list">
                                                            <span>Coupon discounts ({offer}%)</span>
                                                            <span>{currencySymbol}&nbsp;{couponDiscount}</span>
                                                        </div>

                                                        <hr className="summary_devide_line" />

                                                        <div className="billing_summary_list">
                                                            <span>Sub total</span>
                                                            <span>{currencySymbol}&nbsp;{subTotal}</span>
                                                        </div>
                                                        <div className="billing_summary_list">
                                                            <span>Tax ({tax}%)</span>
                                                            <span>{currencySymbol}&nbsp;{taxAmount}</span>
                                                        </div>

                                                        <hr className="summary_devide_line" />

                                                        <div className="billing_summary_list">
                                                            <h6>Total</h6>
                                                            <h4>{currencySymbol}&nbsp;{total}</h4>
                                                        </div>
                                                    </div>
                                                </article>
                                            </Slide>
                                        </div>

                                        <div className="col-12 col-xl-6 col-lg-6 col-md-10 col-sm-10 mx-auto">
                                            <Slide direction="up" triggerOnce>
                                                <article className="page_card h-100">
                                                    <h5 className="page_card_sub_head text-start">Payment Methods</h5>

                                                    {/* <div className="payment_methods_section mt-4">
                                                        {paymentMethodsData && paymentMethodsData?.length > 0 ? (
                                                            <Accordion activeIndex={0} className="pay_method_container">
                                                                {paymentMethodsData?.map((pay_method) => (
                                                                    <AccordionTab
                                                                        key={pay_method.id}
                                                                        header={
                                                                            <div className="pay_method_header_area">
                                                                                <img src={pay_method?.logo} alt={pay_method?.type} />
                                                                                <h6>{pay_method.type}</h6>
                                                                                <Ripple pt={{ root: { style: { background: 'rgba(144, 71, 202, 0.4)' } } }} />
                                                                            </div>
                                                                        }
                                                                        className="pay_method_tab"
                                                                        contentClassName="pay_method_content"
                                                                        headerClassName="pay_method_header"
                                                                    >
                                                                        <div className="payment_form_area">
                                                                            <div className="row">
                                                                                <div className="col-12">
                                                                                    <div className="custom_form_group">
                                                                                        <label htmlFor="cardNumber" className="custom_form_label is_required">Card number</label>
                                                                                        <InputText
                                                                                            id="cardNumber"
                                                                                            value={cardNumber}
                                                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => formatCardNumber(e.target.value)}
                                                                                            onBlur={validateCardNumber}
                                                                                            className="custom_form_input"
                                                                                            placeholder="Card number"
                                                                                            autoComplete="cc-number"
                                                                                        />

                                                                                        {cardNumberError &&
                                                                                            <small className="form_error_msg">{cardNumberError}</small>
                                                                                        }
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-6">
                                                                                    <div className="custom_form_group">
                                                                                        <label htmlFor="expiryDate" className="custom_form_label is_required">Expiry</label>
                                                                                        <InputText
                                                                                            id="expiryDate"
                                                                                            value={expiryDate}
                                                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => formatExpiryDate(e.target.value)}
                                                                                            onBlur={validateExpiryDate}
                                                                                            className="custom_form_input"
                                                                                            placeholder="MM/YY"
                                                                                            autoComplete="cc-exp"
                                                                                        />
                                                                                        {expiryDateError &&
                                                                                            <small className="form_error_msg">{expiryDateError}</small>
                                                                                        }
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-6">
                                                                                    <div className="custom_form_group">
                                                                                        <label htmlFor="cvv" className="custom_form_label is_required">CVV</label>
                                                                                        <InputText
                                                                                            id="cvv"
                                                                                            value={cvv}
                                                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCvv(e.target.value.replace(/\D/g, ''))}
                                                                                            onBlur={validateCvv}
                                                                                            className="custom_form_input"
                                                                                            placeholder="CVV"
                                                                                            maxLength={3}
                                                                                            autoComplete="cc-csc"
                                                                                        />
                                                                                        {cvvError &&
                                                                                            <small className="form_error_msg">{cvvError}</small>
                                                                                        }
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12">
                                                                                    <div className="custom_form_action_area">
                                                                                        <div className="custom_form_check_group">
                                                                                            <Checkbox inputId="isSaveCardDetail" className="rounded" onChange={e => setIsSaveCardDetail(e.checked ?? false)} checked={isSaveCardDetail}></Checkbox>
                                                                                            <label htmlFor="isSaveCardDetail" className="custom_form_check_label2">
                                                                                                Save this details for faster payment.
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-12">
                                                                                    <div className="custom_form_btn_area mt-0">
                                                                                        <Button
                                                                                            label={`${loading ? 'Processing' : 'PAY NOW'}`}
                                                                                            className="custom_form_btn letter_spaced w-100"
                                                                                            loading={loading}
                                                                                            onClick={handleMakePayment}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </AccordionTab>
                                                                ))}
                                                            </Accordion>
                                                        ) : (null)}
                                                    </div> */}

                                                    <div className="page_form_group mb-2">
                                                        {loadingPaymentMethods ? (
                                                            <div className="payment_option_area">
                                                                <Skeleton className="payment_option_loading">
                                                                    <Skeleton className="logo" />
                                                                    <Skeleton className="label" />
                                                                </Skeleton>
                                                            </div>
                                                        ) : (
                                                            <React.Fragment>
                                                                {paymentMethodsData && paymentMethodsData?.length > 0 ? (
                                                                    <div className="payment_option_area">
                                                                        {paymentMethodsData?.map((paymentMethod) => (
                                                                            <button
                                                                                key={paymentMethod?.id}
                                                                                className="payment_option p-ripple"
                                                                                onClick={() => handlePurchasePayWith(paymentMethod)}
                                                                            //disabled={selectedSubscriptionPlan === null}
                                                                            >
                                                                                <div className="payment_option_info">
                                                                                    <Image
                                                                                        src={baseURL + paymentMethod?.logo}
                                                                                        alt={paymentMethod?.type}
                                                                                    />
                                                                                    <p>{paymentMethod?.type}</p>
                                                                                </div>

                                                                                <i className="bi bi-chevron-right"></i>
                                                                                <Ripple />
                                                                            </button>
                                                                        ))}
                                                                    </div>
                                                                ) : (
                                                                    <div className="no_records_found" style={{ minHeight: "15vh" }}>
                                                                        <i className="bi bi-exclamation-circle me-1"></i>
                                                                        No payment option(s) found.
                                                                    </div>
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </div>
                                                </article>
                                            </Slide>
                                        </div>
                                    </React.Fragment>
                                ) : paymentpage === 2 ? (
                                    <div className="col-11 col-xl-10 col-sm-10 mx-auto">
                                        <div className="payment_status_container">
                                            {paymentStatus === 'Success' ? (
                                                <React.Fragment>
                                                    <div className="payment_response_area">
                                                        <i className="bi bi-check-circle-fill success"></i>
                                                        <h5>Payment Successful.</h5>
                                                        <p>
                                                            Your payment has been successfully processed. Thank you for your purchase!
                                                        </p>
                                                    </div>
                                                    <div className="row w-100">
                                                        <div className="col-12 mx-auto col-xxl-6 col-xl-7 p-0">
                                                            <div className="payment_response_summary">
                                                                <div className="billing_summary_list">
                                                                    <h6>Total</h6>
                                                                    <h4>{currencySymbol}&nbsp;60.00</h4>
                                                                </div>

                                                                <hr className="summary_devide_line" />

                                                                <div className="billing_summary_list">
                                                                    <span>Package Rental</span>
                                                                    <span>{currencySymbol}&nbsp;50.00</span>
                                                                </div>

                                                                <div className="billing_summary_list">
                                                                    <span>Coupon discounts (0.0%)</span>
                                                                    <span>{currencySymbol}&nbsp;00.00</span>
                                                                </div>

                                                                <hr className="summary_devide_line" />

                                                                <div className="billing_summary_list">
                                                                    <span>Sub total</span>
                                                                    <span>{currencySymbol}&nbsp;50.00</span>
                                                                </div>

                                                                <div className="billing_summary_list">
                                                                    <span>Tax (20%)</span>
                                                                    <span>{currencySymbol}&nbsp;10.00</span>
                                                                </div>

                                                                <hr className="summary_devide_line" />

                                                                <div className="billing_summary_list">
                                                                    <span>Amount charged</span>
                                                                    <span>{currencySymbol}&nbsp;50.00</span>
                                                                </div>

                                                                <Button
                                                                    icon="bi bi-cloud-download"
                                                                    label={`Download receipt`}
                                                                    className="custom_form_btn retry_btn w-100 mt-3"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            ) : (
                                                <div className="payment_response_area">
                                                    <i className="bi bi-check-circle-fill danger"></i>
                                                    <h5>Payment Failed!</h5>
                                                    <p>
                                                        Something went wrong with your payment. Please try again.
                                                    </p>
                                                    <Button
                                                        icon="bi bi-arrow-counterclockwise"
                                                        label={`Retry`}
                                                        className="custom_form_btn retry_btn"
                                                        onClick={handleRetryPayment}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : null}
                            </React.Fragment>
                        ) : (step === 'Welcome' && showWelcome) ? (
                            <div className="col-11 col-sm-12 mx-auto">
                                <article className="welcome_card">
                                    <div className="welcome_content">
                                        <i className="bi bi-check-circle-fill welcome_icon"></i>
                                        <h6 className="welcome_text">
                                            <span className="text-capitalize">{firstName} </span>
                                            , You have successfully registered.
                                        </h6>
                                    </div>
                                </article>
                            </div>
                        ) : (null)}
                    </div>
                </div>
            </section>

            {/* For purchase new subscription */}
            <CheckoutForm
                isOpen={showPurchaseCheckoutForm}
                onClose={() => setShowPurchaseCheckoutForm(false)}
                onPaymentSuccess={handlePurchasePaymentSuccess}
                amount={purchasePaidTotal * 100}
            />
            {/*  */}
        </React.Fragment>
    )
}

export default Signup;